import React, { Component } from 'react';
import Header from './component/common/Header';
import Footer from './component/common/Footer';
import Page1 from './component/pages/Page1';

class App extends Component {
  render() {
    return (
      <div className="wrapper">
        <div className="myContainer">
          {/*<Header />*/}
          <main className="main-container">
            <Page1/>
          </main>
        </div>
        {/*<Footer/>*/}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js